// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== 0) Reset ========== */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  margin: 0;
}

/* ========== 1) Root & Variables ========== */
:root {
  /* layout vars */
  --header-h: 55px;
  --footer-h: 0px;
  --sidebar-w: 200px;

  /* scrollbar vars */
  --sb-size: 5px;

  /* page frame */
  background-color: #fff;
  /* min-width: 1920px; */
  /* 화면이 더 좁으면 가로 스크롤 */
  max-width: 600px;
  /* 더 넓으면 중앙 정렬 */
  margin: 0 auto;
}

/* ========== 2) Layout ========== */
.App {
  width: 100%;
  position: relative;
  /* border-right: 1px solid #f5f5f5; */
  /* border-left: 1px solid #f5f5f5; */
    outline: none;
    -webkit-tap-highlight-color: transparent;
}

.App-section {
  height: 100dvh;
  padding: 0;
  overflow: hidden;
  /* 페이지(Y) 스크롤 방지, 내부에서만 스크롤 */
  display: flex;
  flex-direction: column;
}

/* 주의: 클래스명 'App-sction-box'는 오타 같지만 기존 코드와 동일하게 유지 */
.App-sction-box {
  flex: 1 1 auto;
  min-height: 0;
  /* padding: 20px; */
  overflow: auto;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;;;EAGE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;EAElB,mBAAmB;EACnB,cAAc;;EAEd,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,oCAAoC;IAClC,aAAa;IACb,wCAAwC;AAC5C;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":["/* ========== 0) Reset ========== */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0;\n}\n\n/* ========== 1) Root & Variables ========== */\n:root {\n  /* layout vars */\n  --header-h: 55px;\n  --footer-h: 0px;\n  --sidebar-w: 200px;\n\n  /* scrollbar vars */\n  --sb-size: 5px;\n\n  /* page frame */\n  background-color: #fff;\n  /* min-width: 1920px; */\n  /* 화면이 더 좁으면 가로 스크롤 */\n  max-width: 600px;\n  /* 더 넓으면 중앙 정렬 */\n  margin: 0 auto;\n}\n\n/* ========== 2) Layout ========== */\n.App {\n  width: 100%;\n  position: relative;\n  /* border-right: 1px solid #f5f5f5; */\n  /* border-left: 1px solid #f5f5f5; */\n    outline: none;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.App-section {\n  height: 100dvh;\n  padding: 0;\n  overflow: hidden;\n  /* 페이지(Y) 스크롤 방지, 내부에서만 스크롤 */\n  display: flex;\n  flex-direction: column;\n}\n\n/* 주의: 클래스명 'App-sction-box'는 오타 같지만 기존 코드와 동일하게 유지 */\n.App-sction-box {\n  flex: 1 1 auto;\n  min-height: 0;\n  /* padding: 20px; */\n  overflow: auto;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
